// emoji icons
import { OBJECT_TYPE, PEN_TYPE } from "./@drawing";
import emojiIcons from "./assets/svg/emoji";

// element ids
const containerId = "whiteboard-container";

// pen colors
const penColors = [
	"#F32828",
	"#2595FF",
	"#83C800",
	"#FFCB00",
	"#F66086",
	"#3B55FF",
	"#00A514",
	"#FA8411",
	"#E455EE",
	"#922FFF",
	"#00B8BC",
	"#C3624E"
];

// thickness range
const thicknessRange = { min: 1, max: 60, default: 5 };

// default
const defaultObjectStyle = {
	penType: PEN_TYPE.PEN,
	objectType: OBJECT_TYPE.FREE_LINE,
	strokeColor: penColors[0],
	fillColor: "transparent",
	thickness: thicknessRange.default,
	alpha: 1,
	emojiSourceIndex: 0
};

const Presets = {
	containerId,
	penColors,
	thicknessRange,
	emojiIcons,
	defaultObjectStyle
};

export default Presets;
